
"use client";

import { Link } from "react-router";
import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import styles from "./Lucky5.module.css";
import CasinoHeading from "../../casinoComponents/casinoHeading";

import VideoBox from "../../casinoComponents/videoBox";
import MyBet from "../../casinoComponents/myBet";
import card1 from '../../../assets/img/card/10.jpg';
import card2 from '../../../assets/img/card/11.jpg';
import card3 from '../../../assets/img/card/12.jpg';
import cardPattiBack from '../../../assets/img/card/patti_back.jpg';


import { getCasinoGameDetails, getMyBets } from '../../../apiservices/CasionApi';
import BetTableLucky5 from "../../casinoComponents/betTableLucky5";
import ResultLucky5 from "../resultui/resultLucky5";

function extractCasinoGame(url) {
  const match = url.match(/\/casino\/([^/?#]+)/);
  return match ? match[1] : null;
}

function transformLucky5Data(sub, gameData = {}) {
  const find = (name) => sub.find((item) => item.nat.toLowerCase() === name.toLowerCase());

  // Extract center card from gameData if available, default to "6"
  const centerCard = gameData?.data?.data?.centerCard || 
                     gameData?.data?.centerCard || 
                     gameData?.centerCard || 
                     "6";

  return {
    b: sub.every((item) => item.b === 0) ? 0 : 1,
    lowCardData: find("Low Card") || {},
    highCardData: find("High Card") || {},
    evenData: find("Even") || {},
    oddData: find("Odd") || {},
    redData: find("Red") || {},
    blackData: find("Black") || {},
    centerCard: centerCard,
  };
}

export default function Lucky5() {
  const [gameData, setGameData] = useState(null);
  const [subData, setSubData] = useState({});
  const [activeTab, setActiveTab] = useState("game");
  const [betValue, setBetValue] = useState("");
  const [showPlaceBet, setShowPlaceBet] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [selectedSelection, setSelectedSelection] = useState("");
  const [selectedBetData, setSelectedBetData] = useState(null);
  const [iframeSrc, setIframeSrc] = useState("");
  const [myBets, setMyBets] = useState([]);
  const [exposures, setExposures] = useState({});

  const { pathname } = useLocation();

  useEffect(() => {
    const name = extractCasinoGame(pathname);
    setIframeSrc(`https://casino-stream.softgamingapi.com/casino-tv?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
        const sub = response?.data?.data?.sub || [];
        const transformed = transformLucky5Data(sub, response);
        setSubData(transformed);
      } catch (err) {
        console.error("Error fetching Lucky 5 game data: ", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname]);

  // When a bet button clicked in BetTableLucky7
  const handleBetClick = (value, playerName, betType, betData) => {
    if (!value) return;
    setBetValue(value);
    setSelectedPlayer(playerName);
    setSelectedSelection(betData?.nat || playerName);
    setSelectedBetData(betData);
    setShowPlaceBet(true);
  };

  const handleBetPlaced = () => {
    // Clear all bet-related state to hide PlaceBet UI
    setShowPlaceBet(false);
    setBetValue("");
    setSelectedPlayer("");
    setSelectedSelection("");
    setSelectedBetData(null);
    fetchMyBetsData();
  };

  const fetchMyBetsData = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id;
      const matchId = gameData?.mid?.toString() || gameData?.data?.data?.mid?.toString() || gameData?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMyBets(userId, matchId);
        if (response.success && response.bets) {
          const formattedBets = response.bets.map((bet) => ({
            matchedBet: bet.player_name || bet.selection || "",
            odds: bet.odds || "0",
            stake: bet.stake || "0",
            type: bet.type || null,
            selection: bet.selection || bet.player_name || "",
            exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0
          }));
          setMyBets(formattedBets);

          // Map exposure from myBets to exposures object
          const exposureMap = {};
          response.bets.forEach((bet) => {
            const selection = bet.selection || bet.player_name || "";
            const exposureAmount = parseFloat(bet.exposer || bet.exposure_amount || "0") || 0;
            if (selection && exposureAmount !== 0) {
              // Add the selection as-is
              exposureMap[selection] = exposureAmount;
              // Also add normalized versions for matching
              exposureMap[selection.trim()] = exposureAmount;
              exposureMap[selection.toLowerCase().trim()] = exposureAmount;
              exposureMap[selection.toLowerCase()] = exposureAmount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching my bets:', error);
    }
  }, [gameData?.mid, gameData?.data?.data?.mid, gameData?.data?.mid]);

  useEffect(() => {
    const matchId = gameData?.mid?.toString() || gameData?.data?.data?.mid?.toString() || gameData?.data?.mid?.toString();
    if (!matchId) return;

    const timeoutId = setTimeout(() => {
      fetchMyBetsData();
    }, 2000);

    const intervalId = setInterval(() => {
      fetchMyBetsData();
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [fetchMyBetsData, gameData?.mid, gameData?.data?.data?.mid, gameData?.data?.mid]);



  const playerA = {
    cards: [card1, card2, card3],
  };

  const playerB = {
    cards: [cardPattiBack, cardPattiBack, cardPattiBack],
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className={styles.container}>
      <div className={styles.sectionA}>
        <CasinoHeading
          name="LUCKY 5"
          roundId={gameData?.data?.data?.mid || gameData?.data?.mid || gameData?.mid || "157250124095658"}
          placedBetCount={myBets.length}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />

        {activeTab === "game" && (
          <>
            <VideoBox playerA={playerA} playerB={playerB} iframeSrc={iframeSrc} timerValue={gameData?.data?.data?.lt} />

            <div className={styles.tableContainer}>
              <BetTableLucky5
                data={subData}
                sub={gameData?.data?.data?.sub || []}
                onBetClick={handleBetClick}
                exposures={exposures}
                myBets={myBets}
              />
            </div>

            <div className={styles.heading}>
              <div>Last Result</div>
              <Link to="/casino/results">
                <div className={styles.viewAll}>View All</div>
              </Link>
            </div>

            <ResultLucky5
              data={gameData?.lrs || []}
              gameData={gameData}
            />
          </>
        )}
        {activeTab === "placedBet" && (
          <div className={styles.myBetMobileContainer}>
            <MyBet bets={myBets} />
          </div>
        )}
      </div>

      <div className={`${styles.placeBet} ${showPlaceBet ? styles.visible : ''}`}>
        {betValue && selectedBetData && (
          <PlaceBet
            betValue={betValue}
            playerName={selectedPlayer}
            playerNameForApi={selectedBetData?.nat || selectedPlayer}
            setShowPlaceBet={setShowPlaceBet}
            gameId={gameData?.data?.data?.mid?.toString() || gameData?.data?.mid?.toString() || gameData?.mid?.toString() || "98765"}
            gameName="lucky5"
            roundId={gameData?.data?.data?.mid || gameData?.data?.mid || gameData?.mid || 0}
            selection={selectedSelection}
            betData={selectedBetData}
            onBetPlaced={handleBetPlaced}
          />
        )}
        <div className={styles.myBetContainer}>
          <MyBet bets={myBets} />
        </div>
      </div>
    </div>
  );
}
